import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid'
import { useState } from 'react'

interface IProps {
  id: number
  title: string
  children: JSX.Element
  expanded?: boolean
}

const Accordion = ({
  id,
  title,
  children,
  expanded = false,
  ...rest
}: IProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded)

  return (
    <div id='accordionGroup'>
      <h3 className='text-c20'>
        <button
          type='button'
          className='w-full text-left flex items-center'
          id={`${id}-header`}
          aria-controls={`${id}-panel`}
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {title}
          {isExpanded ? (
            <ChevronUpIcon width={20} className='ml-auto' />
          ) : (
            <ChevronDownIcon width={20} className='ml-auto' />
          )}
        </button>
      </h3>

      <section
        id={`${id}-panel`}
        aria-labelledby={`${id}-header`}
        hidden={!isExpanded}
        className='font-normal'
      >
        {children}
      </section>
    </div>
  )
}

export default Accordion
